import loadable from '@loadable/component';
import { useCompanyShareLink } from '@/hooks/useCompanyShareToken';

const BrandingBar = loadable(() => import('./components/BrandingBar'), {
  ssr: false,
});
const TopBar = loadable(() => import('./components/TopBar'));

export const DesktopTopbar = () => {
  const { isSharedCompany, logo } = useCompanyShareLink();
  return isSharedCompany ? <BrandingBar logo={logo} /> : <TopBar />;
};
